import requestV2 from '@/utils/requestV2'
const qs = require('qs')

// 当前登录用户绑定F码 和 欧孚士微信公众号
export function bindfcode (data) {
  return requestV2({
    url: '/ooh-os/v1/bindfcode',
    method: 'post',
    data: qs.stringify(data)
  })
}
export function getNewWxCode (data) {
  return requestV2({
    url: '/ooh-os/v1/getqrcode',
    method: 'post',
    data: qs.stringify(data)
  })
}
export function getWxLoginPage () {
  return requestV2({
    url: '/ooh-os/v1/wxLoginPage',
    method: 'get'
  })
}
